import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { IonProgressBar } from '@ionic/angular/standalone';

import { LoadingStateService } from '../../services/loading-state.service';

@Component({
  selector: 'cmn-progress-bar',
  styleUrls: ['./progress-bar.component.scss'],
  templateUrl: './progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonProgressBar],
})
export class ProgressBarComponent {
  public readonly color = input<string>();
  private readonly loadingStateService = inject(LoadingStateService);
  public readonly displayProgressBar = this.loadingStateService.loading;
}
